import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'cigna-message-delete-dialog',
  templateUrl: './message-delete-dialog.component.html',
  styleUrls: ['./message-delete-dialog.component.scss'],
})
export class MessageDeleteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<
      MessageDeleteDialogComponent,
      { canDelete: boolean } | void
    >,
  ) {}
}
